import { Component } from 'react';
import PropTypes from 'prop-types';
import replaceValueInEvent from '../../../helper/replaceValueInEvent';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';

class SwitchComponent extends Component {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e) {
    if (this.props.readOnly) {
      return;
    }
    const value = e.target.checked;

    this.props.onChangeHandler(replaceValueInEvent(e, value));
  }

  render() {
    const {
      name,
      id,
      trueLabel,
      falseLabel,
      errors,
      readOnly,
      autoFocus,
    } = this.props;

    const label = this.props.value ? trueLabel : falseLabel;

    let classNames = 'switch-group';
    if (hasErrors(errors)) {
      classNames += ' has-errors';
    }

    return (
      <div>
        <div className={classNames}>
          <label className="switch" htmlFor={id}>
            <input
              autoFocus={autoFocus}
              readOnly={readOnly}
              type="checkbox"
              name={name}
              id={id}
              checked={this.props.value}
              onChange={this.onChangeHandler}
            />
            <div className="flex-container">
              <div className="slider-body" />
              <div className="slider-description">{label}</div>
              <div className="slider-dot" />
            </div>
          </label>
        </div>
        <ErrorComponent errors={errors} />
      </div>
    );
  }
}

SwitchComponent.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.bool,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  trueLabel: PropTypes.string,
  falseLabel: PropTypes.string,
  onChangeHandler: PropTypes.func,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

SwitchComponent.defaultProps = {
  name: null,
  value: false,
  readOnly: false,
  autoFocus: false,
  trueLabel: 'Ja',
  falseLabel: 'Nee',
  onChangeHandler: () => {
  },
  errors: null,
};

export default SwitchComponent;
